/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { cssMap, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// The stack scales to the width of its clipping window; the viewBox keeps the ratio.
const styles = cssMap({
	root: {
		display: 'block',
		width: '100%',
		height: 'auto',
	},
});

export const MicrosoftSuiteCardStack = ({ testId }: { testId?: string }): React.JSX.Element => (
	<svg
		css={styles.root}
		width="333"
		height="135"
		viewBox="0 0 333 135"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		role="presentation"
		data-testid={testId}
	>
		<g filter="url(#filter0_dd_70_9506)">
			<g clipPath="url(#clip0_70_9506)">
				<rect
					x="6.87573"
					y="23.4559"
					width="160"
					height="104"
					rx="12"
					transform="rotate(-4 6.87573 23.4559)"
					fill={token('elevation.surface.raised')}
				/>
				<rect
					x="15.4143"
					y="30.8784"
					width="144"
					height="88"
					rx="12"
					transform="rotate(-4 15.4143 30.8784)"
					fill={token('elevation.surface.sunken')}
				/>
				<g opacity="0.05">
					<path
						d="M38.8956 102.68C36.1437 102.975 36.1392 105.108 38.9545 105.263C42.9394 105.477 47.087 105.456 52.4182 105.237C58.4486 104.854 59.9302 104.34 64.0239 104.189C70.9348 103.853 82.6141 103.855 85.4256 103.864C85.842 103.867 86.257 103.85 86.6708 103.815C89.6387 103.588 102.67 102.594 113.906 102.212C121.832 101.843 126.741 101.621 129.306 101.5C135.346 101.244 139.883 100.837 144.245 100.404C146.456 100.249 146.897 98.4063 144.269 98.097C139.76 97.7144 135.225 97.6922 129.152 97.912C126.796 98.0127 121.864 97.7109 114.933 97.9522C113.803 97.9928 112.675 98.078 111.564 98.2134C101.939 99.3731 89.4004 99.8144 89.4004 99.8144C89.4004 99.8144 70.7047 100.744 62.8116 101.136C56.8705 101.423 54.0119 101.566 52.257 101.65C46.9408 101.9 42.8099 102.253 38.8951 102.674L38.8956 102.68Z"
						fill={token('color.text')}
					/>
					<path
						d="M36.846 73.3697C34.0942 73.6646 34.0896 75.7971 36.905 75.9524C40.8898 76.1668 45.0375 76.1457 50.3686 75.9266C56.399 75.5433 57.8807 75.0299 61.9744 74.8781C68.8853 74.5421 80.5645 74.545 83.376 74.5533C83.7924 74.5562 84.2075 74.54 84.6212 74.5047C87.5891 74.2779 100.62 73.2835 111.856 72.9011C119.783 72.5325 124.691 72.311 127.257 72.1892C133.296 71.9334 137.833 71.5265 142.195 71.0934C144.406 70.9388 144.847 69.0959 142.22 68.7866C137.711 68.404 133.176 68.3817 127.102 68.6016C124.746 68.7023 119.814 68.4004 112.884 68.6417C111.753 68.6824 110.626 68.7676 109.515 68.9029C99.889 70.0627 87.3508 70.504 87.3508 70.504C87.3508 70.504 68.6551 71.4336 60.762 71.8254C54.8209 72.1128 51.9624 72.2551 50.2074 72.3394C44.8912 72.5895 40.7604 72.9424 36.8456 73.3634L36.846 73.3697Z"
						fill={token('color.text')}
					/>
				</g>
				<path
					d="M33.1303 50.3547C33.0413 49.0829 34.0001 47.9799 35.2717 47.891L48.3175 46.9787L49.2479 60.2832C49.3071 61.1311 48.668 61.8666 47.8203 61.9259L37.0763 62.6772C35.3812 62.7957 33.9108 61.5172 33.7923 59.8217L33.1303 50.3547Z"
					fill="url(#paint0_radial_70_9506)"
				/>
				<path
					d="M33.1303 50.3547C33.0413 49.0829 34.0001 47.9799 35.2717 47.891L48.3175 46.9787L49.2479 60.2832C49.3071 61.1311 48.668 61.8666 47.8203 61.9259L37.0763 62.6772C35.3812 62.7957 33.9108 61.5172 33.7923 59.8217L33.1303 50.3547Z"
					fill="url(#paint1_radial_70_9506)"
				/>
				<path
					d="M33.3092 52.914C33.2203 51.6421 34.1791 50.5392 35.4506 50.4503L42.3572 49.9674C41.5095 50.0267 40.8703 50.7621 40.9296 51.6099L41.1443 54.6801C41.2036 55.5278 40.5646 56.2634 39.7168 56.3226L36.6474 56.5373C34.9522 56.6558 33.6741 58.1265 33.7927 59.8221L33.3096 52.914L33.3092 52.914Z"
					fill="url(#paint2_linear_70_9506)"
				/>
				<path
					d="M33.3092 52.914C33.2203 51.6421 34.1791 50.5392 35.4506 50.4503L42.3572 49.9674C41.5095 50.0267 40.8703 50.7621 40.9296 51.6099L41.1443 54.6801C41.2036 55.5278 40.5646 56.2634 39.7168 56.3226L36.6474 56.5373C34.9522 56.6558 33.6741 58.1265 33.7927 59.8221L33.3096 52.914L33.3092 52.914Z"
					fill="url(#paint3_linear_70_9506)"
				/>
				<path
					d="M32.9334 47.5402C32.8149 45.8447 34.093 44.374 35.7881 44.2555L41.9274 43.8262L42.3568 49.9669L36.2175 50.3962C34.5224 50.5147 33.2443 51.9854 33.3628 53.6809L32.9334 47.5402Z"
					fill="url(#paint4_linear_70_9506)"
				/>
				<path
					d="M32.9334 47.5402C32.8149 45.8447 34.093 44.374 35.7881 44.2555L41.9274 43.8262L42.3568 49.9669L36.2175 50.3962C34.5224 50.5147 33.2443 51.9854 33.3628 53.6809L32.9334 47.5402Z"
					fill="url(#paint5_radial_70_9506)"
				/>
				<path
					d="M32.9334 47.5402C32.8149 45.8447 34.093 44.374 35.7881 44.2555L41.9274 43.8262L42.3568 49.9669L36.2175 50.3962C34.5224 50.5147 33.2443 51.9854 33.3628 53.6809L32.9334 47.5402Z"
					fill="url(#paint6_linear_70_9506)"
				/>
				<path
					d="M41.9275 43.8261L46.5317 43.5042C47.3794 43.4449 48.1147 44.0841 48.174 44.9317L48.3887 48.0027C48.448 48.8504 47.8088 49.5857 46.9611 49.6449L42.3569 49.9669C41.5092 50.0262 40.7739 49.387 40.7147 48.5393L40.4999 45.4684C40.4406 44.6207 41.0798 43.8854 41.9275 43.8261Z"
					fill="url(#paint7_radial_70_9506)"
				/>
				<path
					d="M32.432 53.2333L37.292 52.8935C38.2103 52.8293 39.0069 53.5217 39.0711 54.4399L39.4111 59.3018C39.4753 60.2202 38.7829 61.0166 37.8645 61.0808L33.0045 61.4206C32.0863 61.4848 31.2897 60.7925 31.2255 59.8742L30.8856 55.0123C30.8213 54.0941 31.5138 53.2975 32.432 53.2333Z"
					fill="url(#paint8_radial_70_9506)"
				/>
				<path
					d="M32.432 53.2333L37.292 52.8935C38.2103 52.8293 39.0069 53.5217 39.0711 54.4399L39.4111 59.3018C39.4753 60.2202 38.7829 61.0166 37.8645 61.0808L33.0045 61.4206C32.0863 61.4848 31.2897 60.7925 31.2255 59.8742L30.8856 55.0123C30.8213 54.0941 31.5138 53.2975 32.432 53.2333Z"
					fill="url(#paint9_radial_70_9506)"
				/>
				<path
					d="M37.4635 59.3469L36.2016 59.4351L35.3052 57.9994C35.2732 57.9491 35.2486 57.9093 35.2314 57.8799C35.2161 57.8483 35.1991 57.8121 35.1811 57.7719L35.1683 57.7728C35.1524 57.8265 35.137 57.8701 35.122 57.9037C35.1068 57.9378 35.0891 57.9793 35.0685 58.0289L34.3502 59.5642L33.1602 59.6474L34.4245 57.2051L32.931 54.9621L34.1764 54.8751L34.9735 56.1571C35.0057 56.2095 35.033 56.2557 35.0554 56.2957C35.0798 56.3332 35.1048 56.3784 35.1304 56.4315L35.1433 56.4305C35.1691 56.3655 35.1895 56.3136 35.2046 56.2756C35.2216 56.2373 35.2444 56.1866 35.2725 56.1236L35.9106 54.7545L37.0974 54.6715L35.9086 57.0662L37.4638 59.3472L37.4635 59.3469Z"
					fill="white"
				/>
			</g>
		</g>
		<g filter="url(#filter1_dd_70_9506)">
			<g clipPath="url(#clip1_70_9506)">
				<rect
					x="166.388"
					y="13.1191"
					width="160"
					height="104"
					rx="12"
					transform="rotate(4 166.388 13.1191)"
					fill={token('elevation.surface.raised')}
				/>
				<rect
					x="173.81"
					y="21.6577"
					width="144"
					height="88"
					rx="12"
					transform="rotate(4 173.81 21.6577)"
					fill={token('elevation.surface.sunken')}
				/>
				<g opacity="0.05">
					<path
						d="M190.873 98.1791C188.107 98.0881 187.806 100.199 190.572 100.745C194.488 101.512 198.598 102.068 203.908 102.593C209.933 103.053 211.472 102.751 215.547 103.17C222.437 103.799 234.003 105.427 236.786 105.827C237.197 105.888 237.611 105.929 238.025 105.952C240.996 106.141 254.038 106.969 265.218 108.154C273.119 108.893 278.011 109.356 280.568 109.593C286.584 110.18 291.134 110.408 295.514 110.587C297.725 110.741 298.418 108.978 295.859 108.306C291.447 107.299 286.96 106.646 280.914 106.019C278.568 105.79 273.725 104.805 266.829 104.08C265.704 103.962 264.575 103.89 263.456 103.869C253.763 103.678 241.285 102.37 241.285 102.37C241.285 102.37 222.642 100.689 214.771 99.9783C208.848 99.436 205.997 99.1791 204.248 99.0183C198.949 98.5261 194.809 98.3006 190.874 98.1727L190.873 98.1791Z"
						fill={token('color.text')}
					/>
					<path
						d="M192.923 68.8687C190.157 68.7777 189.855 70.8888 192.622 71.4344C196.538 72.2013 200.648 72.7576 205.958 73.2826C211.983 73.7423 213.522 73.4401 217.596 73.8596C224.487 74.4887 236.052 76.1169 238.835 76.5164C239.247 76.5773 239.66 76.619 240.075 76.6416C243.046 76.8301 256.088 77.6589 267.268 78.844C275.169 79.5822 280.06 80.0459 282.618 80.2824C288.634 80.8695 293.183 81.098 297.563 81.2762C299.774 81.4308 300.468 79.6673 297.909 78.9953C293.497 77.9889 289.009 77.3357 282.964 76.7081C280.617 76.48 275.775 75.4947 268.878 74.7691C267.753 74.652 266.625 74.5795 265.506 74.5589C255.812 74.3677 243.335 73.0597 243.335 73.0597C243.335 73.0597 224.692 71.3783 216.821 70.6679C210.898 70.1256 208.047 69.8686 206.297 69.7079C200.998 69.2157 196.858 68.9902 192.923 68.8623L192.923 68.8687Z"
						fill={token('color.text')}
					/>
				</g>
				<path
					d="M301.848 54.6696C302.233 49.1601 298.079 44.3817 292.571 43.9965C287.062 43.6112 282.283 47.7651 281.898 53.2746C281.513 58.7841 285.666 63.5625 291.175 63.9477C296.684 64.333 301.462 60.1791 301.848 54.6696Z"
					fill="url(#paint10_linear_70_9506)"
				/>
				<path
					d="M301.848 54.6696C302.233 49.1601 298.079 44.3817 292.571 43.9965C287.062 43.6112 282.283 47.7651 281.898 53.2746C281.513 58.7841 285.666 63.5625 291.175 63.9477C296.684 64.333 301.462 60.1791 301.848 54.6696Z"
					fill="url(#paint11_radial_70_9506)"
				/>
				<path
					d="M301.848 54.6696C302.233 49.1601 298.079 44.3817 292.571 43.9965C287.062 43.6112 282.283 47.7651 281.898 53.2746C281.513 58.7841 285.666 63.5625 291.175 63.9477C296.684 64.333 301.462 60.1791 301.848 54.6696Z"
					fill="url(#paint12_radial_70_9506)"
				/>
				<path
					d="M292.572 43.9965C298.081 44.3819 302.234 49.1603 301.849 54.6697C301.721 56.5024 301.106 58.1844 300.14 59.6L300.327 59.2523C301.468 57.1295 300.037 54.5369 297.632 54.3706L293.662 54.0961C292.675 54.0279 291.93 53.1718 291.999 52.1849L292.278 48.2076C292.446 45.8027 290.075 44.0263 287.814 44.8635L287.485 44.9857C289.013 44.2375 290.753 43.8693 292.572 43.9965Z"
					fill="url(#paint13_linear_70_9506)"
				/>
				<path
					d="M292.572 43.9965C298.081 44.3819 302.234 49.1603 301.849 54.6697C301.721 56.5024 301.106 58.1844 300.14 59.6L300.327 59.2523C301.468 57.1295 300.037 54.5369 297.632 54.3706L293.662 54.0961C292.675 54.0279 291.93 53.1718 291.999 52.1849L292.278 48.2076C292.446 45.8027 290.075 44.0263 287.814 44.8635L287.485 44.9857C289.013 44.2375 290.753 43.8693 292.572 43.9965Z"
					fill="url(#paint14_radial_70_9506)"
				/>
				<path
					d="M292.572 43.9965C298.081 44.3819 302.234 49.1603 301.849 54.6697C301.721 56.5024 301.106 58.1844 300.14 59.6L300.327 59.2523C301.468 57.1295 300.037 54.5369 297.632 54.3706L293.662 54.0961C292.675 54.0279 291.93 53.1718 291.999 52.1849L292.278 48.2076C292.446 45.8027 290.075 44.0263 287.814 44.8635L287.485 44.9857C289.013 44.2375 290.753 43.8693 292.572 43.9965Z"
					fill="url(#paint15_radial_70_9506)"
				/>
				<path
					d="M292.572 43.9965C298.081 44.3819 302.234 49.1603 301.849 54.6697C301.721 56.5024 301.106 58.1844 300.14 59.6L300.327 59.2523C301.468 57.1295 300.037 54.5369 297.632 54.3706L293.662 54.0961C292.675 54.0279 291.93 53.1718 291.999 52.1849L292.278 48.2076C292.446 45.8027 290.075 44.0263 287.814 44.8635L287.485 44.9857C289.013 44.2375 290.753 43.8693 292.572 43.9965Z"
					fill="url(#paint16_radial_70_9506)"
				/>
				<path
					d="M292.572 43.9965C298.081 44.3819 302.234 49.1603 301.849 54.6697C301.721 56.5024 301.106 58.1844 300.14 59.6L300.327 59.2523C301.468 57.1295 300.037 54.5369 297.632 54.3706L293.662 54.0961C292.675 54.0279 291.93 53.1718 291.999 52.1849L292.278 48.2076C292.446 45.8027 290.075 44.0263 287.814 44.8635L287.485 44.9857C289.013 44.2375 290.753 43.8693 292.572 43.9965Z"
					fill="url(#paint17_radial_70_9506)"
				/>
				<path
					d="M283 52.8159L288.054 53.1693C289.009 53.2361 289.729 54.0643 289.662 55.0193L289.309 60.0736C289.242 61.0287 288.414 61.7486 287.459 61.6818L282.404 61.3284C281.449 61.2616 280.729 60.4334 280.796 59.4784L281.15 54.4241C281.216 53.469 282.045 52.7491 283 52.8159Z"
					fill="url(#paint18_radial_70_9506)"
				/>
				<path
					d="M283 52.8159L288.054 53.1693C289.009 53.2361 289.729 54.0643 289.662 55.0193L289.309 60.0736C289.242 61.0287 288.414 61.7486 287.459 61.6818L282.404 61.3284C281.449 61.2616 280.729 60.4334 280.796 59.4784L281.15 54.4241C281.216 53.469 282.045 52.7491 283 52.8159Z"
					fill="url(#paint19_radial_70_9506)"
				/>
				<path
					d="M284.755 58.0675L284.644 59.6516L283.549 59.5751L283.889 54.7107L285.581 54.829C286.187 54.8714 286.638 55.0359 286.936 55.3227C287.237 55.6095 287.368 56.013 287.332 56.5331C287.295 57.0691 287.087 57.4749 286.709 57.7508C286.333 58.0267 285.845 58.1437 285.246 58.1018L284.755 58.0675ZM284.925 55.6285L284.813 57.2262L285.271 57.2582C285.542 57.2771 285.757 57.2207 285.913 57.0884C286.07 56.9562 286.158 56.7567 286.177 56.4899C286.194 56.2434 286.135 56.0484 286 55.9047C285.866 55.7613 285.667 55.6804 285.4 55.6617L284.925 55.6285Z"
					fill="white"
				/>
			</g>
		</g>
		<g filter="url(#filter2_dd_70_9506)">
			<rect
				x="81.5081"
				y="8"
				width="160"
				height="104"
				rx="12"
				fill={token('elevation.surface.raised')}
			/>
			<g clipPath="url(#clip2_70_9506)">
				<rect
					x="89.5081"
					y="16"
					width="144"
					height="88"
					rx="12"
					fill={token('elevation.surface.sunken')}
				/>
				<g opacity="0.05">
					<g clipPath="url(#clip3_70_9506)">
						<path
							d="M204.759 40.2357C204 39.0511 203.37 37.9907 202.816 37.0856C202.261 36.1849 201.817 35.4173 201.485 34.7917C200.815 33.5361 200.584 32.8395 200.748 32.7197C200.917 32.5999 201.485 33.0658 202.425 34.1395C202.896 34.6763 203.459 35.3641 204.111 36.2115C204.759 37.0589 205.464 38.0838 206.263 39.2596C207.412 40.9145 208.468 42.6494 209.577 44.3753C210.119 45.2449 210.638 46.1367 211.175 47.0285C211.441 47.4722 211.707 47.9203 211.973 48.3684C212.226 48.8254 212.484 49.2824 212.741 49.7439C214.817 53.4043 216.761 57.2865 218.456 61.4926C220.133 65.6943 221.619 70.2376 222.187 75.2779C222.458 77.7891 222.515 80.4335 222.036 83.1311C221.566 85.8198 220.488 88.5706 218.642 90.9C218.154 91.5877 217.537 92.1334 216.978 92.7102C216.69 92.9853 216.366 93.216 216.069 93.4645C215.762 93.7041 215.474 93.9614 215.146 94.1522C214.507 94.5604 213.894 94.9819 213.242 95.2792C212.923 95.4389 212.603 95.5986 212.293 95.7583C211.969 95.887 211.649 96.0112 211.334 96.1399C208.797 97.1204 206.374 97.5286 204.16 97.7283C199.71 98.0877 196.032 97.6174 192.686 97.014C189.341 96.3839 186.306 95.5454 183.143 94.4761C179.979 93.3979 176.683 92.0846 172.894 90.2655C166.496 87.1908 159.357 82.8205 152.653 77.3233C145.935 71.8482 139.679 65.2373 134.799 58.2448C132.354 54.7575 130.247 51.1903 128.507 47.7029C128.09 46.8244 127.664 45.9637 127.27 45.1074C126.897 44.2422 126.533 43.3903 126.178 42.5562L126.045 42.2412L125.912 41.8862C125.819 41.6511 125.752 41.4115 125.681 41.1719C125.544 40.6927 125.442 40.2091 125.371 39.7255C125.233 38.7582 125.229 37.791 125.34 36.8637C125.57 35.0002 126.285 33.3054 127.341 31.9566L127.531 31.6992L127.758 31.4552C127.913 31.2955 128.064 31.1402 128.219 30.9849C128.383 30.8385 128.574 30.7054 128.752 30.5678C128.929 30.4303 129.111 30.3016 129.324 30.204C129.528 30.0975 129.732 29.9955 129.936 29.9023C130.154 29.8313 130.375 29.7692 130.593 29.7115C130.81 29.6405 131.028 29.6139 131.245 29.6006C131.462 29.5829 131.68 29.5562 131.888 29.5607C132.718 29.6006 133.477 29.7692 134.098 30.0265C134.413 30.1508 134.724 30.275 134.981 30.4303C135.247 30.5767 135.527 30.7098 135.748 30.8695C135.979 31.0248 136.205 31.1757 136.423 31.3177C136.622 31.473 136.818 31.6238 137.004 31.7702C137.386 32.0542 137.683 32.347 137.976 32.6043C139.32 33.8378 140.46 35.1999 141.507 36.6064C142.444 37.862 143.695 39.6944 145.088 42.0681C146.477 44.4418 148.021 47.3568 149.591 50.751C151.162 54.1452 152.781 58.0141 154.321 62.2912C155.865 66.5684 157.351 71.2492 158.616 76.2717C159.872 81.2942 160.954 86.6539 161.433 92.302C161.54 93.7174 161.633 95.1416 161.633 96.5925C161.655 97.3157 161.62 98.0433 161.611 98.7754C161.562 99.5075 161.544 100.24 161.46 100.98C161.327 102.458 161.092 103.949 160.688 105.431C160.284 106.913 159.725 108.399 158.855 109.779C158.629 110.12 158.421 110.471 158.141 110.781C157.879 111.105 157.618 111.429 157.303 111.713L156.846 112.152C156.681 112.286 156.508 112.41 156.335 112.538C156.167 112.663 155.985 112.8 155.83 112.907L155.395 113.195C154.818 113.586 154.259 113.998 153.718 114.429L153.314 114.757L152.844 115.121L152.364 115.489C152.2 115.604 152.027 115.711 151.859 115.822C150.505 116.7 149.006 117.339 147.466 117.738C145.927 118.142 144.347 118.315 142.794 118.324C139.679 118.337 136.654 117.747 133.787 116.86C130.917 115.981 128.188 114.801 125.584 113.479C121.914 111.589 118.622 109.446 115.641 107.214C112.664 104.974 109.997 102.635 107.65 100.222C105.312 97.7993 103.266 95.3147 101.713 92.6171C100.955 91.2549 100.307 89.844 99.9786 88.2689C99.8189 87.4836 99.7612 86.6406 99.881 85.7799C99.9875 84.9236 100.347 84.0318 100.906 83.3396C101.461 82.6519 102.153 82.1106 102.849 81.7912C103.022 81.6936 103.195 81.6181 103.368 81.556C103.541 81.4895 103.714 81.4229 103.887 81.3563C104.229 81.2543 104.571 81.1611 104.908 81.0813C106.261 80.7973 107.623 80.7663 108.888 80.9792C111.435 81.383 113.569 82.6386 115.108 84.1604C115.303 84.3468 115.481 84.5553 115.663 84.7461C115.836 84.9369 115.978 85.1188 116.133 85.3007C116.444 85.6601 116.728 86.0283 117.012 86.3833C117.575 87.0932 118.09 87.7898 118.569 88.4597C119.523 89.7997 120.326 91.0508 121.023 92.1822C124.292 97.5464 126.684 102.933 128.49 108.195C130.273 113.466 131.462 118.648 131.822 123.755C131.986 126.306 131.955 128.839 131.56 131.32C131.183 133.791 130.429 136.227 129.138 138.383C127.86 140.539 125.983 142.358 123.782 143.477C122.691 144.04 121.542 144.466 120.375 144.754C119.208 145.025 118.028 145.207 116.852 145.273C115.561 145.344 114.434 145.296 113.484 145.194C113.01 145.132 112.575 145.087 112.18 145.016C111.789 144.941 111.439 144.87 111.128 144.799C109.895 144.484 109.314 144.195 109.345 144.022C109.376 143.84 110.019 143.774 111.257 143.792C111.869 143.796 112.637 143.805 113.555 143.809C114.469 143.809 115.53 143.783 116.728 143.676C117.819 143.583 118.893 143.379 119.94 143.108C120.983 142.815 121.985 142.412 122.926 141.893C124.812 140.868 126.36 139.288 127.434 137.389C128.516 135.49 129.155 133.298 129.457 131.013C129.776 128.728 129.772 126.346 129.577 123.928C129.164 119.083 127.966 114.087 126.2 108.989C124.412 103.9 122.061 98.6645 118.897 93.4911C118.281 92.4884 117.557 91.3614 116.692 90.1546C115.831 88.9567 114.82 87.6256 113.657 86.3389C112.566 85.1587 111.04 84.1471 109.225 83.7167C108.32 83.5038 107.353 83.4106 106.377 83.5348C105.888 83.5792 105.396 83.699 104.921 83.841C104.673 83.8987 104.473 84.014 104.242 84.0939C104.131 84.1382 104.043 84.2048 103.941 84.2536C103.843 84.3068 103.732 84.3557 103.657 84.4266C103.28 84.6618 103.036 84.9724 102.84 85.3096C102.805 85.4027 102.738 85.4782 102.716 85.5758C102.69 85.6734 102.658 85.771 102.623 85.8686C102.592 86.086 102.539 86.2945 102.548 86.5386C102.521 86.7693 102.57 87.0311 102.583 87.284C102.636 87.5457 102.663 87.8075 102.752 88.0826C102.88 88.6283 103.111 89.1874 103.351 89.7464C104.389 92.0003 106.053 94.2365 107.969 96.3972C109.895 98.5668 112.127 100.665 114.589 102.698C117.052 104.73 119.754 106.677 122.686 108.479C124.594 109.655 126.56 110.737 128.57 111.7C130.575 112.663 132.625 113.515 134.715 114.176C135.837 114.544 136.986 114.846 138.153 115.085C139.32 115.334 140.5 115.493 141.689 115.56C144.059 115.711 146.463 115.436 148.615 114.544C149.689 114.1 150.701 113.506 151.606 112.765C152.129 112.334 152.666 111.922 153.221 111.531C153.496 111.336 153.775 111.145 154.055 110.959L154.481 110.684L154.809 110.44C156.571 109.158 157.684 106.952 158.279 104.619C158.452 104.042 158.549 103.434 158.678 102.84C158.762 102.232 158.878 101.633 158.926 101.016C159.073 99.7959 159.108 98.558 159.135 97.3245C159.157 94.8577 158.975 92.4041 158.7 90.0038C158.132 85.2031 157.174 80.611 156.078 76.3738C153.882 67.895 151.189 60.8093 149.086 55.8978C148.03 53.4397 147.129 51.5142 146.481 50.2097C146.166 49.5531 145.904 49.0562 145.736 48.719C145.563 48.3818 145.474 48.2043 145.474 48.2043C145.474 48.2043 145.336 47.9425 145.079 47.45C144.822 46.9531 144.436 46.2254 143.921 45.3026C142.887 43.4613 141.361 40.7948 139.107 37.8354C137.976 36.3757 136.649 34.8183 135.016 33.5627C134.204 32.9549 133.295 32.4313 132.399 32.245C131.502 32.0764 130.704 32.2849 129.967 32.9327C129.248 33.6026 128.61 34.6098 128.241 35.6835C127.873 36.7661 127.735 37.9596 127.864 39.1531C127.926 39.7477 128.055 40.3466 128.25 40.9279L128.405 41.3627L128.605 41.8374C128.738 42.1524 128.871 42.4719 129.004 42.7913C129.28 43.4258 129.524 44.078 129.83 44.708C130.127 45.3425 130.429 45.9814 130.73 46.6203C131.99 49.1626 133.37 51.7138 134.963 54.1807C135.726 55.4363 136.587 56.6343 137.421 57.8588C137.851 58.4623 138.304 59.0524 138.743 59.6513L139.409 60.5476L140.105 61.4172C143.788 66.0936 147.99 70.3707 152.333 74.1554C161.061 81.698 170.431 87.0444 177.73 90.1014C180.472 91.2816 183.103 92.2089 185.592 92.972C186.834 93.3669 188.054 93.6686 189.23 93.9792C189.82 94.1211 190.401 94.2409 190.974 94.3696C191.546 94.5027 192.11 94.6092 192.664 94.7024C197.101 95.5276 200.979 95.643 204.249 95.3235C207.523 94.9908 210.168 94.1345 212.213 93.0607C214.263 91.9781 215.691 90.656 216.707 89.3693C218.256 87.4126 219.192 85.0833 219.622 82.7052C220.057 80.3181 220.022 77.8956 219.782 75.553C219.285 70.8499 217.914 66.453 216.335 62.3534C214.742 58.2493 212.901 54.407 210.931 50.7643C210.687 50.3073 210.447 49.8503 210.203 49.3978C209.95 48.9497 209.697 48.5015 209.444 48.0579C208.934 47.1705 208.446 46.2787 207.931 45.4046C206.871 43.6743 205.877 41.9306 204.781 40.2623L204.759 40.2357Z"
							fill={token('color.text')}
						/>
					</g>
				</g>
				<path
					d="M106.008 44.545L113.008 36L121.008 41V47.25C121.008 48.215 120.223 49 119.258 49H109.008C107.353 49 106.008 47.655 106.008 46V44.545Z"
					fill="url(#paint20_radial_70_9506)"
				/>
				<path
					d="M106.008 38.52C106.008 37.275 107.013 36.27 108.258 36.27H118.453L121.008 35V41.25C121.008 42.215 120.223 43 119.258 43H109.008C107.353 43 106.008 44.345 106.008 46V38.52Z"
					fill="url(#paint21_linear_70_9506)"
				/>
				<path
					d="M106.008 38.52C106.008 37.275 107.013 36.27 108.258 36.27H118.453L121.008 35V41.25C121.008 42.215 120.223 43 119.258 43H109.008C107.353 43 106.008 44.345 106.008 46V38.52Z"
					fill="url(#paint22_radial_70_9506)"
					fillOpacity="0.6"
				/>
				<path
					d="M106.008 38.52C106.008 37.275 107.013 36.27 108.258 36.27H118.453L121.008 35V41.25C121.008 42.215 120.223 43 119.258 43H109.008C107.353 43 106.008 44.345 106.008 46V38.52Z"
					fill="url(#paint23_radial_70_9506)"
					fillOpacity="0.1"
				/>
				<path
					d="M106.008 34C106.008 32.345 107.353 31 109.008 31H119.258C120.223 31 121.008 31.785 121.008 32.75V35.25C121.008 36.215 120.223 37 119.258 37H109.008C107.353 37 106.008 38.345 106.008 40V34Z"
					fill="url(#paint24_linear_70_9506)"
				/>
				<path
					d="M106.008 34C106.008 32.345 107.353 31 109.008 31H119.258C120.223 31 121.008 31.785 121.008 32.75V35.25C121.008 36.215 120.223 37 119.258 37H109.008C107.353 37 106.008 38.345 106.008 40V34Z"
					fill="url(#paint25_radial_70_9506)"
					fillOpacity="0.8"
				/>
				<path
					d="M109.883 39.5H105.133C104.236 39.5 103.508 40.2275 103.508 41.125V45.875C103.508 46.7725 104.236 47.5 105.133 47.5H109.883C110.781 47.5 111.508 46.7725 111.508 45.875V41.125C111.508 40.2275 110.781 39.5 109.883 39.5Z"
					fill="url(#paint26_radial_70_9506)"
				/>
				<path
					d="M109.883 39.5H105.133C104.236 39.5 103.508 40.2275 103.508 41.125V45.875C103.508 46.7725 104.236 47.5 105.133 47.5H109.883C110.781 47.5 111.508 46.7725 111.508 45.875V41.125C111.508 40.2275 110.781 39.5 109.883 39.5Z"
					fill="url(#paint27_radial_70_9506)"
					fillOpacity="0.65"
				/>
				<path
					d="M110.253 41.2157L109.268 45.7857H108.093L107.513 43.0457L106.903 45.7907H105.713L104.768 41.2207H105.738L106.323 44.2357L106.903 41.2207H108.093L108.698 44.2357L109.268 41.2207H110.253V41.2157Z"
					fill="white"
				/>
			</g>
		</g>
		<defs>
			<filter
				id="filter0_dd_70_9506"
				x="-1.12427"
				y="4.29492"
				width="182.865"
				height="130.908"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="4" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
				/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_70_9506" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
				/>
				<feBlend
					mode="normal"
					in2="effect1_dropShadow_70_9506"
					result="effect2_dropShadow_70_9506"
				/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_70_9506" result="shape" />
			</filter>
			<filter
				id="filter1_dd_70_9506"
				x="151.133"
				y="5.11914"
				width="182.865"
				height="130.908"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="4" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
				/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_70_9506" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
				/>
				<feBlend
					mode="normal"
					in2="effect1_dropShadow_70_9506"
					result="effect2_dropShadow_70_9506"
				/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_70_9506" result="shape" />
			</filter>
			<filter
				id="filter2_dd_70_9506"
				x="73.5081"
				y="0"
				width="176"
				height="120"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="4" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
				/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_70_9506" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
				/>
				<feBlend
					mode="normal"
					in2="effect1_dropShadow_70_9506"
					result="effect2_dropShadow_70_9506"
				/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_70_9506" result="shape" />
			</filter>
			<radialGradient
				id="paint0_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientTransform="matrix(-15.5626 -14.2405 -11.0448 12.0756 49.4818 62.9869)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.06" stopColor="#379539" />
				<stop offset="0.42" stopColor="#297C2D" />
				<stop offset="0.7" stopColor="#15561C" />
			</radialGradient>
			<radialGradient
				id="paint1_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientTransform="matrix(-6.54327 -5.49824 -4.2529 5.06355 37.989 53.1246)"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#073B10" stopOpacity="0.698039" />
				<stop offset="0.99" stopColor="#084A13" stopOpacity="0" />
			</radialGradient>
			<linearGradient
				id="paint2_linear_70_9506"
				x1="33.4702"
				y1="55.2167"
				x2="40.5224"
				y2="54.7235"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#52D17C" />
				<stop offset="0.33" stopColor="#4AA647" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_70_9506"
				x1="37.7525"
				y1="50.2893"
				x2="38.1999"
				y2="56.6871"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#29852F" stopOpacity="0.301961" />
				<stop offset="0.5" stopColor="#4AA647" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint4_linear_70_9506"
				x1="33.6538"
				y1="51.9864"
				x2="41.6471"
				y2="44.0109"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#66D052" />
				<stop offset="1" stopColor="#85E972" />
			</linearGradient>
			<radialGradient
				id="paint5_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(41.961 47.6412) rotate(176) scale(4.62729 9.79324)"
			>
				<stop offset="0.29" stopColor="#4EB43B" />
				<stop offset="1" stopColor="#72CC61" stopOpacity="0" />
			</radialGradient>
			<linearGradient
				id="paint6_linear_70_9506"
				x1="37.1923"
				y1="48.7852"
				x2="33.0408"
				y2="49.0755"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.18" stopColor="#C0E075" stopOpacity="0" />
				<stop offset="1" stopColor="#D1EB95" />
			</linearGradient>
			<radialGradient
				id="paint7_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientTransform="matrix(-9.14219 -6.39668 6.37744 -9.11809 49.642 50.3988)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.44" stopColor="#79E96D" />
				<stop offset="1" stopColor="#D0EB76" />
			</radialGradient>
			<radialGradient
				id="paint8_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientTransform="matrix(8.75643 7.61453 21.6761 -24.9391 31.0129 53.3767)"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#20A85E" />
				<stop offset="0.94" stopColor="#09442A" />
			</radialGradient>
			<radialGradient
				id="paint9_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(35.299 57.9698) rotate(86) scale(5.74564 6.61775)"
			>
				<stop offset="0.58" stopColor="#33A662" stopOpacity="0" />
				<stop offset="0.97" stopColor="#98F0B0" stopOpacity="0.301961" />
			</radialGradient>
			<linearGradient
				id="paint10_linear_70_9506"
				x1="291.603"
				y1="43.2906"
				x2="278.563"
				y2="54.1282"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.0582736" stopColor="#FF7F48" />
				<stop offset="1" stopColor="#E5495B" />
			</linearGradient>
			<radialGradient
				id="paint11_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(296.109 50.0611) rotate(139) scale(20.0775 33.7931)"
			>
				<stop offset="0.151523" stopColor="#AA1D2D" />
				<stop offset="0.380855" stopColor="#D12B18" stopOpacity="0.439216" />
				<stop offset="0.601996" stopColor="#FF3C00" stopOpacity="0" />
			</radialGradient>
			<radialGradient
				id="paint12_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(277.849 61.14) rotate(-21.2832) scale(19.0325 34.4801)"
			>
				<stop offset="0.4067" stopColor="#FF66FB" stopOpacity="0.501961" />
				<stop offset="1" stopColor="#EA3D01" stopOpacity="0" />
			</radialGradient>
			<linearGradient
				id="paint13_linear_70_9506"
				x1="293.607"
				y1="56.324"
				x2="304.9"
				y2="49.1173"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.310768" stopColor="#FF6E30" />
				<stop offset="0.634576" stopColor="#FFA05C" />
			</linearGradient>
			<radialGradient
				id="paint14_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(290.115 55.0478) rotate(15.8349) scale(12.9275 12.3244)"
			>
				<stop offset="0.78593" stopColor="#FFA05C" stopOpacity="0" />
				<stop offset="0.904889" stopColor="#FFCE84" />
			</radialGradient>
			<radialGradient
				id="paint15_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(292.232 53.8468) rotate(-29.1977) scale(13.0536 12.4833)"
			>
				<stop offset="0.295239" stopColor="#FF99E9" stopOpacity="0.8" />
				<stop offset="0.727968" stopColor="#FF99E9" stopOpacity="0" />
			</radialGradient>
			<radialGradient
				id="paint16_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(290.663 55.2675) rotate(-44.864) scale(13.8981 12.6929)"
			>
				<stop stopColor="#FD6EF9" />
				<stop offset="0.637205" stopColor="#FF9944" />
				<stop offset="0.85186" stopColor="#FCC479" />
			</radialGradient>
			<radialGradient
				id="paint17_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(290.457 45.1735) rotate(102.395) scale(7.07381 15.9869)"
			>
				<stop offset="0.144283" stopColor="#FF8D13" />
				<stop offset="0.537266" stopColor="#FF7F29" stopOpacity="0" />
			</radialGradient>
			<radialGradient
				id="paint18_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(281.269 52.6949) rotate(49) scale(12.0679)"
			>
				<stop stopColor="#F8193E" />
				<stop offset="0.939062" stopColor="#920616" />
			</radialGradient>
			<radialGradient
				id="paint19_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(285.169 58.1) rotate(94) scale(5.97333 6.8)"
			>
				<stop offset="0.575893" stopColor="#FFB055" stopOpacity="0" />
				<stop offset="0.973806" stopColor="#FFF2BE" stopOpacity="0.301961" />
			</radialGradient>
			<radialGradient
				id="paint20_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(121.565 48.882) scale(23.785 10.075)"
			>
				<stop offset="0.18" stopColor="#1657F4" />
				<stop offset="0.57" stopColor="#0036C4" />
			</radialGradient>
			<linearGradient
				id="paint21_linear_70_9506"
				x1="106.008"
				y1="40.5"
				x2="117.493"
				y2="40.5"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#66C0FF" />
				<stop offset="0.26" stopColor="#0094F0" />
			</linearGradient>
			<radialGradient
				id="paint22_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(119.76 38.0381) rotate(133.55) scale(14.68 36.16)"
			>
				<stop offset="0.14" stopColor="#D471FF" />
				<stop offset="0.83" stopColor="#509DF5" stopOpacity="0" />
			</radialGradient>
			<radialGradient
				id="paint23_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(119.422 41.2494) rotate(90) scale(9.31 50.825)"
			>
				<stop offset="0.28" stopColor="#4F006F" stopOpacity="0" />
				<stop offset="1" stopColor="#4F006F" />
			</radialGradient>
			<linearGradient
				id="paint24_linear_70_9506"
				x1="106.008"
				y1="35.39"
				x2="121.008"
				y2="35.64"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#9DEAFF" />
				<stop offset="0.2" stopColor="#3BD5FF" />
			</linearGradient>
			<radialGradient
				id="paint25_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(120.513 29.4736) rotate(166.85) scale(14.745 35.32)"
			>
				<stop offset="0.06" stopColor="#E4A7FE" />
				<stop offset="0.54" stopColor="#E4A7FE" stopOpacity="0" />
			</radialGradient>
			<radialGradient
				id="paint26_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(103.42 38.4355) rotate(45) scale(11.315)"
			>
				<stop offset="0.08" stopColor="#367AF2" />
				<stop offset="0.87" stopColor="#001A8F" />
			</radialGradient>
			<radialGradient
				id="paint27_radial_70_9506"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(108.925 44.276) rotate(90) scale(5.6 6.385)"
			>
				<stop offset="0.59" stopColor="#2763E5" stopOpacity="0" />
				<stop offset="0.97" stopColor="#58AAFE" />
			</radialGradient>
			<clipPath id="clip0_70_9506">
				<rect
					x="6.87573"
					y="23.4559"
					width="160"
					height="104"
					rx="12"
					transform="rotate(-4 6.87573 23.4559)"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip1_70_9506">
				<rect
					x="166.388"
					y="13.1191"
					width="160"
					height="104"
					rx="12"
					transform="rotate(4 166.388 13.1191)"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip2_70_9506">
				<rect x="89.5081" y="16" width="144" height="88" rx="12" fill="white" />
			</clipPath>
			<clipPath id="clip3_70_9506">
				<rect
					width="122.577"
					height="115.757"
					fill="white"
					transform="matrix(-1 0 0 1 222.396 29.5563)"
				/>
			</clipPath>
		</defs>
	</svg>
);
